export default __webpack_public_path__ + "static/media/puffer_ttx.bd856699.jpg";